<template>
  <div class="logisticsPage">
      <vanTitle title="查看物流"></vanTitle>
      <div class="page-info">
		<div class="info-hd" @click="toKechDetail">
			<div class="hd-tit title">{{state.orderInfo.order_name}}</div>
			<div class="hd-status" :class="{'status-01': state.orderInfo.pay_status == '1', 'status-02': state.orderInfo.pay_status == '0'}">{{state.orderInfo.pay_status_val}}</div>
		</div>
		<div class="hd-number" @click.stop="copy(state.orderInfo.order_sn)">订单号: {{state.orderInfo.order_sn}} <i class="icon-copy"></i></div>
		<div class="hd-price price"><span>¥</span>{{state.orderInfo.amount}}</div>
	  </div>
      <multiExpress v-if="state.orderInfo.need_post == 1 && state.orderInfo.pay_status != 2" :order_id="state.id" :multi_express="state.orderInfo.multi_express"></multiExpress>
      <footer class="page-footer">
		<div class="lt">
			<!-- 教育客服 -->
			<div class="ft-btn kefu" v-if="state.orderInfo.reception_id != 0 && state.kefuData.number !== '' && state.orderInfo.platform !== 2">
				<i class="icon-kefu"></i>
				<span class="txt">客服</span>
			</div>
			<!-- 在线客服 -->
			<div class="ft-btn kefu" v-if="state.orderInfo.platform == 2" @click="bindKefu()">
				<i class="icon-kefu"></i>
				<span class="txt">客服</span>
			</div>
		</div>
		<div v-if="state.orderInfo.reception_id != 0 && state.kefuData.number !== '' || !state.orderInfo.express_id"></div>
		<template v-if="state.orderInfo.order_type !== 2 && state.orderInfo.order_type !== 3 && state.orderInfo.order_type !== 4 && state.orderInfo.order_type !== 5">
			<!-- 拼团结束展示学习，图书不展示学习 -->
			<div class="middle-btn" v-if="state.orderInfo.pay_status == 1 && state.orderInfo.flag == 0 || state.orderInfo.pay_status == 1 && state.orderInfo.flag == 1 && state.orderInfo.group_success == 1" @click="bindBuyPop">去学习</div>
		 </template>
	 </footer>
  </div>
  <!-- 购买须知 -->
  <buyNotice :show="state.buyShow" :isBuy="true" @bindBuyPop="bindBuyPop" :orderInfo="state.orderInfo"></buyNotice>
</template>

<script>
import { reactive, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useClipboard from 'vue-clipboard3'
import md5 from 'js-md5';
import multiExpress from "../../components/detail/multiExpress.vue";
import buyNotice from "../../components/detail/buynotice.vue";
export default {
    name: 'orderLogistics',
    components:{
        multiExpress,
		buyNotice
    },
    setup() {
        const $route = useRoute();
        const $router = useRouter();
        const { proxy } = getCurrentInstance();
        const time = Date.parse(new Date());
        const state = reactive({
            orderInfo: [],//订单详情
			kefuData: [],//客服数据
			id: '',//订单ID
			code:'',//wxcode
			browser: '',//1-微信浏览器2-其他浏览器
			is_pc:'',//1-pc端2-移动端
			zxq_qrcode:'',//知小群引流码数据
			buyShow: false
        })
        onMounted(() => {
            state.id = $route.params.id;
            getOrderInfo();
        });
        // 获取订单详情
		const getOrderInfo = () => {
			proxy.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: "加载中..."
			});
			proxy.$http.get("/api/order/detail/" + state.id)
            .then(res => {
                proxy.$toast.clear();
                const body = res.data.data;
                if(res.data.code == '200'){		
                    state.orderInfo = body;
                    isWeiXin();//是否为微信浏览器
                    getKefu(body.dis_id);//获取客服数据

                } else if(res.data.code == '401'){
                    console.log("未登录")
                } else {
                    proxy.$toast(res.data.message);
                }
            })
            .catch(error => console.log(error))
		}

        //判断是否是微信浏览器的函数
		const isWeiXin = () => {
			//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
			var ua = window.navigator.userAgent.toLowerCase();
			//通过正则表达式匹配ua中是否含有MicroMessenger字符串
			if(ua.match(/MicroMessenger/i) == 'micromessenger'){
				state.browser = '1';

				// 获取code
				if(state.orderInfo.pay_status == '0'){
					//为支付获取code
					let code = getUrlParam('code')
					let local = window.location.href;
					let php_time = time.toString().substring(0,10);
					let secret = "getWxCodeFor_purchase.huatu.com";
					let signNew = md5(md5(local + php_time + secret));
					let appid = '';

					// 区分在线和教育公众号appid
					if(state.orderInfo.platform == '2' || (state.orderInfo.department == 3 && state.orderInfo.order_type != 5)){
						// appid = "wx42d6c48d12ecc5a0";
						appid = "wxeac61fb8c5a92283";
					} else {
						appid = "wxeac61fb8c5a92283";
					}
					
					if (code == null || code == '') {
						window.location.href = "https://m-xue.zhongshi.com.cn/mp/proxy.php?appid="+ appid + '&time='+php_time+'&sign='+signNew+'&redirect_url='+ encodeURIComponent(local);
					} else {
						state.code = code
					}
				}
				
			} else{
				state.browser = '2';
			}

			// 判断当前设备是移动端还是PC端
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
			if(flag){
				state.is_pc = 2;
			}else{
				state.is_pc = 1;
			}
		}

        // 获取url code参数
		const getUrlParam = (name) => {
			var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
			let url = window.location.href.split('#')[0]
			let search = url.split('?')[1]
			if (search) {
				var r = search.substr(0).match(reg)
				if (r !== null) return unescape(r[2])
				return null
			} else {
				return null
			}
		}

        // 获取客服参数
		const getKefu = (dis_id) => {
			proxy.$http.get("/api/course/consult/" + dis_id +'/1')
            .then(res => {
                // console.log("客服参数===>", res.data)
                const body = res.data.data;

                if(res.data.code == '200' && body !== null){
                    state.kefuData = body;

                    if(state.kefuData.number){
                        if(state.kefuData.type == '0'){
                            htSobot.init('kefu', {service: 'branch-teach', ehr_code: state.kefuData.number, type: 'js', new_window: false, prod: true});
                        }else if(state.kefuData.type == '1'){
                            htSobot.init('kefu', {service: 'business', sys_id: state.kefuData.number, type: 'js', new_window: false, prod: true});
                        }else if(state.kefuData.type == '2'){
                            htSobot.init('kefu', {service: 'channel', sys_id: state.kefuData.number, type: 'js', new_window: false, prod: true});
                        }
                    }
                } else {
                    // proxy.$toast(res.data.message);
                }
            })
            .catch(error => console.log(error))
		}

        // 跳转课程详情
		const toKechDetail = () => {
			$router.push({
				name: 'detail',
				params: {
					dis_id: state.orderInfo.detail_ref_id
				}
			});
		}

        // 复制订单号
		const { toClipboard } = useClipboard()
		const copy = async (Msg) => {
			try {
				//复制
				await toClipboard(Msg)
				proxy.$toast("复制成功");
			} catch (e) {
				//复制失败
				proxy.$toast("复制失败");
			}
		}

        // 客服
        const bindKefu = () => {
			let url = '';
            let title_info = state.orderInfo.order_name;
            let label_info = state.orderInfo.amount;
            let url_info = encodeURIComponent(window.location.href);
            let tel = userInfo.mobile; 
            // 区分售前售后客服
            if(state.orderInfo.pay_status == 1 && state.orderInfo.flag == 0 || state.orderInfo.pay_status == 1 && state.orderInfo.flag == 1 && state.orderInfo.group_success == 1){
				url = 'https://zsht.soboten.com/chat/h5/v6/index.html?sysnum=9c93277881f44e3e8c23090f055d1ae5&channelid=21&groupid=85183cc2fa3b478eb2fea36ba70f64b8&title_info='+ title_info +'&label_info='+ label_info +'&url_info='+url_info+'&tel='+ tel +'&type=3&robotid=6'
            } else {
				url = 'https://zsht.soboten.com/chat/h5/v6/index.html?sysnum=9c93277881f44e3e8c23090f055d1ae5&channelid=21&groupid=85183cc2fa3b478eb2fea36ba70f64b8&title_info='+ title_info +'&label_info='+ label_info +'&url_info='+url_info+'&tel='+ tel + '&type=4&robotid=6'
            }
            // 跳转客服
            // console.log(url)
            window.location.href = url;
        }

        // bindBuyPop
        const bindBuyPop = () => {
			state.buyShow = !state.buyShow;
        }

        return {
            state,
            bindKefu,
            bindBuyPop,
            toKechDetail,
            copy
        }
    }
}
</script>

<style scoped lang="scss">
.logisticsPage {
    height: 100%;
	background: #F8F9FA;
    .page-info{
		background: #FFFFFF;
		border-radius: 8px;
		margin: 12px 16px 0 16px;
		padding: 15px;
		.info-hd{
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			.hd-tit{
				width: 249px;
				text-align: start;
			}
			.hd-status{
				font-size: 14px;
				color: #9FA6AF;
				line-height: 24px;
			}
			.status-01{
				color: #FC6C21;
			}
			.status-02{
				color: #FF2223;
			}
		}
		.hd-number{
			font-size: 12px;
			color: #999999;
			line-height: 17px;
			padding: 10px 0 13px 0;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			background: none;
			.icon-copy{
				display: block;
				width: 12px;
				height: 12px;
				margin-left: 5px;
				background: url(../../assets/icons/icon-copy.png) center/100% 100% no-repeat;
			}
		}
	}
    .page-footer{
		position: fixed;
		left: 0;
		bottom: 0;
		right: 0;
		padding: 8px 13px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #FFFFFF;
		.lt{
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}
		.ft-btn{
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			margin-left: 10px;
			.icon-kefu{
				display: block;
				width: 20px;
				height: 20px;
				background: url(https://file.huatu.com/static/miniprogram/shop/h5/detail/icon_kefu.png) center/100% 100% no-repeat;
			}
			.icon-wuliu{
				display: block;
				width: 20px;
				height: 20px;
				background: url(../../assets/icons/icon-wuliu.png) center/100% 100% no-repeat;
			}
			.txt{
				font-size: 11px;
				color: #333333;
				line-height: 16px;
			}
		}
	}
}
</style>